import { BannerId } from '../../../typings/banners';
import { ValidationResultItem } from '../../../typings/common';
import { InternalResourceId } from '../../../typings/internalBanners';

export const SHOW_IMAGE_INTERNAL_GALLERY_ERROR = 'SHOW_IMAGE_INTERNAL_GALLERY_ERROR';
export type SHOW_IMAGE_INTERNAL_GALLERY_ERROR = typeof SHOW_IMAGE_INTERNAL_GALLERY_ERROR;

export interface ShowImageInternalGalleryError {
    type: SHOW_IMAGE_INTERNAL_GALLERY_ERROR;
    bannerId: BannerId;
    resourceId: InternalResourceId;
    errors: ValidationResultItem[];
}

export function showImageInternalGalleryErrorAction(
    bannerId: BannerId,
    resourceId: InternalResourceId,
    errors: ValidationResultItem[]
): ShowImageInternalGalleryError {
    return {
        type: SHOW_IMAGE_INTERNAL_GALLERY_ERROR,
        bannerId,
        resourceId,
        errors
    };
}
